(function () {
  'use strict';

  function getScrollAmount(viewport) {
    return Math.max(120, Math.floor(viewport.clientWidth * 0.75));
  }

  function updateArrows(nav) {
    var viewport = nav.querySelector('[data-internal-links-viewport]');
    var prev = nav.querySelector('[data-internal-links-prev]');
    var next = nav.querySelector('[data-internal-links-next]');
    if (!viewport || !prev || !next) return;

    var maxScroll = viewport.scrollWidth - viewport.clientWidth;
    var tol = 2;
    var canLeft = viewport.scrollLeft > tol;
    var canRight = viewport.scrollLeft < maxScroll - tol;

    function setBtn(btn, show) {
      if (show) {
        btn.hidden = false;
        btn.removeAttribute('disabled');
      } else {
        btn.hidden = true;
        btn.setAttribute('disabled', 'disabled');
      }
    }

    setBtn(prev, canLeft);
    setBtn(next, canRight);

    var hasOverflow = maxScroll > tol;
    nav.classList.toggle('collection-internal-links--fade-left', hasOverflow && canLeft);
    nav.classList.toggle('collection-internal-links--fade-right', hasOverflow && canRight);
  }

  function bindNav(nav) {
    var viewport = nav.querySelector('[data-internal-links-viewport]');
    var prev = nav.querySelector('[data-internal-links-prev]');
    var next = nav.querySelector('[data-internal-links-next]');
    if (!viewport || !prev || !next) return;

    prev.addEventListener('click', function () {
      viewport.scrollBy({ left: -getScrollAmount(viewport), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      viewport.scrollBy({ left: getScrollAmount(viewport), behavior: 'smooth' });
    });

    viewport.addEventListener('scroll', function () {
      updateArrows(nav);
    });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(function () {
        updateArrows(nav);
      });
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', function () {
        updateArrows(nav);
      });
    }

    updateArrows(nav);
    window.requestAnimationFrame(function () {
      updateArrows(nav);
    });
  }

  function init() {
    document.querySelectorAll('[data-collection-internal-links]').forEach(bindNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
